import { Button, Callout, Field } from "@gf/ui";
import { useState, type FormEvent } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { AuthHeading, AuthLayout } from "./AuthLayout";
import { PasswordInput } from "./PasswordInput";
import { MIN_PASSWORD } from "../../components/accounts/shared";

export function ChangeTemporaryPassword() {
  const { refresh, logout } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password.length < MIN_PASSWORD) { setError(`Use at least ${MIN_PASSWORD} characters.`); return; }
    if (password !== confirm) { setError("Passwords must match."); return; }
    setBusy(true); setError(null);
    try {
      await api("/api/auth/complete-setup", { method: "POST", body: { password } });
      await refresh();
    } catch (error) { setError(error instanceof Error ? error.message : "Please try again."); }
    finally { setBusy(false); }
  }
  return <AuthLayout title="Choose your password">
    <AuthHeading title="Make your account yours" lede="Choose your own password to finish setting up your GramFather account. Then your portal will connect the Chrome extension for you." />
    <form className="gfp-auth__form" onSubmit={submit}>
      <Field label="New password" hint={`At least ${MIN_PASSWORD} characters.`}><PasswordInput value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" autoFocus /></Field>
      <Field label="Confirm new password"><PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" /></Field>
      {error && <Callout tone="danger">{error}</Callout>}
      <Button type="submit" block loading={busy}>Save password and open GramFather</Button>
      <Button type="button" variant="ghost" block onClick={() => void logout()}>Sign out</Button>
    </form>
  </AuthLayout>;
}
